module.exports = __webpack_public_path__ + "assets/img/3w.996b884d.png";